import {AppState, AppDispatch} from '../store';
import { useDispatch, useSelector } from "react-redux";
import { fetchListReportStudentModule, fetchReportStudentExamActivity, fetchReportStudentPracticeActivity, fetchStudentDashboardClassModuleStats, fetchDashboardStudentV2, exportDashboardCompletion, exportDashboardPracticeResults } from "@store/actions/studentDashboardAction";
import { setFilterData } from "@store/reducers/studentDashboardReducer";
export const useStudentDashboard = () => {
  const loading = useSelector((state: AppState) => state.studentDashboard.loading)
  const listStudentModule = useSelector((state: AppState) => state.studentDashboard.listStudentModule)
  const filterData = useSelector((state: AppState) => state.studentDashboard.filterData)
  const examDashboardData = useSelector((state: AppState) => state.studentDashboard.examDashboardData)
  const practiceDashboardData = useSelector((state: AppState) => state.studentDashboard.practiceDashboardData)
  const classModuleStats = useSelector((state: AppState) => state.studentDashboard.classModuleStats)
  const dashboardStudentV2 = useSelector((state: AppState) => state.studentDashboard.dashboardStudentV2)
  const exportCompletionLoading = useSelector((state: AppState) => state.studentDashboard.exportCompletionLoading)
  const exportPracticeResultsLoading = useSelector((state: AppState) => state.studentDashboard.exportPracticeResultsLoading)
  
  const dispatch: AppDispatch = useDispatch();

  const fetchListReportStudentModuleAction = () => {
    dispatch(fetchListReportStudentModule())
  }

  const fetchReportStudentExamActivityAction = ({module_id, start_date,  end_date}: {module_id: number, start_date: string, end_date: string}) => {
    dispatch(fetchReportStudentExamActivity({module_id, start_date, end_date}))
  }

  const fetchReportStudentPracticeActivityAction = ({module_id, start_date,  end_date}: {module_id: number, start_date: string, end_date: string, status: 2}) => {
    dispatch(fetchReportStudentPracticeActivity({module_id, start_date, end_date, status: 2}))
  }

  const fetchStudentDashboardClassModuleStatsAction = ({class_id, from_date, to_date}: {class_id: number, from_date: string, to_date: string}) => {
    dispatch(fetchStudentDashboardClassModuleStats({class_id, from_date, to_date}))
  }

  const fetchDashboardStudentV2Action = () => {
    dispatch(fetchDashboardStudentV2())
  }

  const exportDashboardCompletionAction = () => {
    dispatch(exportDashboardCompletion())
  }

  const exportDashboardPracticeResultsAction = () => {
    dispatch(exportDashboardPracticeResults())
  }

  const setFilterDataAction = (data: any) => {
    dispatch(setFilterData(data))
  }

  return { 
    fetchListReportStudentModuleAction,
    fetchReportStudentExamActivityAction,
    fetchReportStudentPracticeActivityAction,
    fetchStudentDashboardClassModuleStatsAction,
    fetchDashboardStudentV2Action,
    exportDashboardCompletionAction,
    exportDashboardPracticeResultsAction,
    listStudentModule,
    classModuleStats,
    setFilterDataAction,
    practiceDashboardData,
    examDashboardData,
    filterData,
    dashboardStudentV2,
    loading,
    exportCompletionLoading,
    exportPracticeResultsLoading,
  }

}